<template>
  <div>
    <div class="right_items">
      <div class="img_show">
        <img
          src="@/assets/img/12.1salesreturnflow01.svg"
          alt
          srcset
        />
        <div
          class="node nodemodule_one"
          @click="toSaveClick"
          v-cust
        >
          <flow-popover
            :title="`退货方案修改审批`"
            :check-data="offerCheckData"
          ></flow-popover>
        </div>
        <div
          class="node nodemodule_two"
          @click="toSaveClick_left"
          v-cust
        >
          <flow-popover
            :title="`结算方案审批`"
            :check-data="specialCheckData"
          ></flow-popover>
        </div>
      </div>
    </div>
    <foot-bar @save="saveSubmit"></foot-bar>
    <flow-dialog
      :data-key="dataKey"
      :node-data="dialogData"
      :dialog-visible.sync="dialogVisible"
      @successEv="toSave"
    ></flow-dialog>
  </div>
</template>

<script>

import flowMixin from '@/mixin/flowMixin'

export default {
  name: 'salesreturnsflow',
  mixins: [flowMixin],
  data () {
    return {
      offerCheckData: {
        id: 110
      }, // 合同审批
      specialCheckData: {
        id: 127
      }, // 合同盖章审批
      pageIds: [{
        id: 30,
        key: 'offerCheckData'
      }, {
        id: 35,
        key: 'specialCheckData'
      }],
      issuc: true
    }
  },
  methods: {
    saveSubmit () {
      this.issuc = true
      const { specialCheckData, offerCheckData } = this
      const paramsArr = this.formatterParamas([specialCheckData, offerCheckData])
      this.saveData(paramsArr)
    },
    toSaveClick () {
      this.dataKey = 'offerCheckData'
      this.showDialog()
    },
    toSaveClick_left () {
      this.dataKey = 'specialCheckData'
      this.showDialog()
    }
  }
}
</script>
<style
  scoped
  lang="less"
>
  @import "/src/assets/less/flow.less";

  .nodemodule_one {
    .common(169px, 46px, 0px, 132px);
  }

  .nodemodule_two {
    .common(154px, 46px, 0px, 345px);
  }
</style>
